import { render, staticRenderFns } from "./account_header.vue?vue&type=template&id=64b8688a"
import script from "./account_header.vue?vue&type=script&lang=js"
export * from "./account_header.vue?vue&type=script&lang=js"
import style0 from "./account_header.vue?vue&type=style&index=0&id=64b8688a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports